import CreateClientStore from './client.create';
import ClientDetailsStore from './client.details';
import ListClientStore from './client.list';

export const clientStores = {
  create: CreateClientStore,
  list: ListClientStore,
  details: ClientDetailsStore
};
